<template>
  <image
    v-if="color && shadowLink && !anonymousCrossOrigin"
    :width="width"
    :height="height"
    :xlink:href="shadowLink"
  ></image>
  <img
    v-else-if="color && shadowLink"
    :src="shadowLink"
    crossorigin="anonymous"
  />
</template>

<script>
import { mapGetters } from "vuex";
import CONSTANTS from "@/constants.js";

export default {
  name: "VariantShadow",
  props: {
    product: {
      type: Object,
    },
    side: {
      type: String,
    },
    gender: {
      type: String,
    },
    designDimension: {
      type: Object,
    },
    anonymousCrossOrigin: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters("project", ["isPlaybook", "isSnapsheet", "color1"]),

    color() {
      return this[`color1`];
    },

    width() {
      return this.designDimension ? this.designDimension.width : 800;
    },

    height() {
      return this.designDimension ? this.designDimension.height : 1000;
    },

    variant() {
      //First Snapsheet variant
      if (this.isSnapsheet && this.product.variant) {
        return this.product.variants?.find(
          (v) => v?.color_name?.trim() === this.product.variant?.trim()
        );
      }
      //For Instant Playbook
      else {
        //Search for customized variant
        let variant = this.product.variants?.find(
          (v) => v?.color_name?.trim() === this.product.variant?.trim()
        );

        if (variant) return variant;

        //Search for variant that match with the playbook color
        variant = this.product.variants?.find(
          (v) => v.color_family === this.color1?.id
        );

        if (variant) return variant;
        //Search for Backup colors
        else {
          const backupColorIds = CONSTANTS.BACKUP_STOCK_COLOR_IDS;
          for (let index = 0; index < backupColorIds.length; index++) {
            const colorId = backupColorIds[index];
            variant = this.product.variants?.find(
              (v) => v.color_family === colorId
            );
            if (variant) return variant;
          }
          return null;
        }
      }
    },

    shadowLink() {
      const gender = this.product.genders ? this.product.genders[0] : this.gender
      return this.isPlaybook ?
        (gender == null || this.variant == null)
          ? false
          : this.variant.backgrounds[
              `shadow_${gender.toLowerCase()}_${this.side}`
            ]
        :
        this.variant?.backgrounds[
          Object.keys(this.variant.backgrounds)[2]
        ]; //Call the 'front' image
    },

  },
};
</script>